module.exports = __webpack_public_path__ + "img/campaign.9eea8c13.jpg";